import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import { Timer } from 'lib-shared-legacy-components';
import { memo, useMemo } from 'react';
import { TvDashboardMetric } from './components/metric/tvDashboardMetric';
import styles from './tvDashboardMetrics.module.scss';
export const TvDashboardMetrics = memo(function TvDashboardMetrics({ queue, isLoading, }) {
    const metrics = useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const inQueue = (_a = queue === null || queue === void 0 ? void 0 : queue.conversations_in_queue) !== null && _a !== void 0 ? _a : 0;
        const total = (_b = queue === null || queue === void 0 ? void 0 : queue.total_conversations) !== null && _b !== void 0 ? _b : 0;
        const answered = (_c = queue === null || queue === void 0 ? void 0 : queue.answered_conversations) !== null && _c !== void 0 ? _c : 0;
        const transferred = (_d = queue === null || queue === void 0 ? void 0 : queue.transfered_conversations) !== null && _d !== void 0 ? _d : 0;
        const abandoned = (_e = queue === null || queue === void 0 ? void 0 : queue.abandoned_conversations) !== null && _e !== void 0 ? _e : 0;
        const slaPercentage = (_f = queue === null || queue === void 0 ? void 0 : queue.service_level) !== null && _f !== void 0 ? _f : 0;
        const answeredPercentage = (answered / (abandoned + answered)) * 100;
        const phoneAgents = (_g = queue === null || queue === void 0 ? void 0 : queue.available_agents.pstn_phone) !== null && _g !== void 0 ? _g : 0;
        const chatAgents = (_h = queue === null || queue === void 0 ? void 0 : queue.available_agents.widget_chat) !== null && _h !== void 0 ? _h : 0;
        const emailAgents = (_j = queue === null || queue === void 0 ? void 0 : queue.available_agents.email) !== null && _j !== void 0 ? _j : 0;
        const messagingAgents = (_k = queue === null || queue === void 0 ? void 0 : queue.available_agents.facebook_messenger) !== null && _k !== void 0 ? _k : 0;
        return [
            {
                title: 'In queue',
                stat: inQueue,
                color: colors.orange[400],
            },
            {
                title: 'Total',
                stat: total,
            },
            {
                title: 'Answered',
                stat: answered,
                color: colors.green[500],
            },
            {
                title: 'Timeouts',
                stat: transferred,
            },
            {
                title: 'Abandoned',
                stat: abandoned,
                color: colors.red[500],
            },
            {
                title: 'SLA',
                stat: slaPercentage ? `${slaPercentage.toFixed(1)}%` : '-',
            },
            {
                title: 'Answered',
                stat: answeredPercentage ? `${answeredPercentage.toFixed(1)}%` : '-',
                color: colors.green[500],
            },
            {
                title: 'Current longest wait time',
                stat: (queue === null || queue === void 0 ? void 0 : queue.longest_wait) ? (_jsx(Timer, { asCounter: false, start: true, startAt: queue.longest_wait, textFitProps: { max: 70 } })) : ('00:00:00'),
            },
            {
                title: 'Average handling time',
                stat: (queue === null || queue === void 0 ? void 0 : queue.average_handling_time) ? (_jsx(Timer, { asCounter: true, start: false, startAt: queue.average_handling_time, textFitProps: { max: 70 } })) : ('00:00:00'),
            },
            {
                title: 'Average wait time',
                stat: (queue === null || queue === void 0 ? void 0 : queue.average_waiting_time) ? (_jsx(Timer, { asCounter: true, start: false, startAt: queue.average_waiting_time, textFitProps: { max: 70 } })) : ('00:00:00'),
            },
            ...[
                phoneAgents > 0 && { title: 'Phone agents', stat: phoneAgents },
                chatAgents > 0 && { title: 'Chat agents', stat: chatAgents },
                emailAgents > 0 && { title: 'Email agents', stat: emailAgents },
                messagingAgents > 0
                    ? { title: 'Messaging agents', stat: messagingAgents }
                    : null,
            ].filter(Boolean),
        ];
    }, [queue]);
    return (_jsx("div", Object.assign({ className: styles.grid }, { children: metrics.map(({ title, color, stat }, index) => (_jsx("div", Object.assign({ className: styles.item }, { children: isLoading ? (_jsx(Spinner, { size: 32, color: colors.neutral[100], trackColor: colors.neutral[700] }, index)) : (_jsx(TvDashboardMetric, { title: title, stat: stat, color: color })) }), index))) })));
});
